import axios from 'axios'
import store from '../store'
import { getAxiosUrl, getCookie } from '@/js/public'
/**
 * 使用Vuex的store之前需要先引入，
 * 1.通过store.state.tokenStr获取属性值
 * 2.通过store.commit('mutations中的方法名',tokenStr)设置属性值
 */
// 初始化配置
function initAxios (whichPost, isfile, noToken) {
  const useurl = getAxiosUrl(whichPost)
  // 设置api访问基路径
  axios.defaults.baseURL = useurl
  // 是否允许请求携带cookie
  // axios.defaults.withCredentials = true
  // 这里使用了Vuex中的常量（需要先引入store）
  const haveToken = !noToken ? getCookie('readStar') : false
  if (haveToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${haveToken}`
    axios.defaults.headers.delete.Authorization = `Bearer ${haveToken}`
    // console.log(axios.defaults.headers)
  }
  // axios.defaults.headers.common['tokenStr'] = store.state.tokenStr
  // 设置响应头
  if (!isfile) {
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    axios.defaults.headers.delete['Content-Type'] = 'application/json'
    axios.defaults.headers.delete.Accept = 'application/json, text/plain, */*'
  } else {
    axios.defaults.headers.common['Content-Type'] = 'multipart/form-data;charset=utf-8'
    axios.defaults.headers['Content-Type'] = 'multipart/form-data;charset=utf-8'
    // console.log(axios.defaults.headers)
  }
}
/**
 * GET 方式请求数据
 * @param hasParamUrl  请求url（已经拼接好的路径）
 * @param callback 回调函数
 */
export async function getData (hasParamUrl, data, whichPost, isLoading, callback, isLocal) {
  // console.log(hasParamUrl, data, whichPost, isLoading, callback, isLocal)
  if (hasParamUrl === null) return
  // if (isLoading) store.commit('showLoadMask', true)
  if (isLoading) store.dispatch('showLoad', true)
  let resData
  initAxios(whichPost)
  if (data) {
    data.reflesh = (new Date()).getTime()
  } else {
    data = {
      reflesh: (new Date()).getTime()
    }
  }
  if (isLocal) { axios.defaults.baseURL = '' }
  await axios.get(hasParamUrl, { params: data }).then(function (response) {
    backView(response, callback)
    resData = response.data
  }).catch(function (error) {
    console.log(error)
    resData = error
  })
  if (isLoading) store.dispatch('showLoad', false)
  return resData
}

/**
 * POST 方式请求
 */
export async function postData (hasParamUrl, data, whichPost, isLoading, callback, noToken) {
  if (hasParamUrl === null) return
  if (isLoading) store.commit('showLoadMask', true)
  initAxios(whichPost, '', noToken)
  let resData
  await axios.post(hasParamUrl, data).then(function (response) {
    // 存储token到Vuex的state
    // store.commit('setTokenStr', response.data.tokenStr)
    backView(response, callback)
    resData = response.data
  }).catch(function (error) {
    console.log(error)
    resData = error
  })
  if (isLoading) store.commit('showLoadMask', false)
  return resData
}

/**
 * PUT 方式请求
 */
export async function putData (hasParamUrl, data, whichPost, isLoading, callback) {
  if (hasParamUrl === null) return
  if (isLoading) store.commit('showLoadMask', true)
  initAxios(whichPost)
  let resData
  await axios.put(hasParamUrl, data).then(function (response) {
    // 存储token到Vuex的state
    // store.commit('setTokenStr', response.data.tokenStr)
    backView(response, callback)
    resData = response.data
  }).catch(function (error) {
    console.log(error)
    resData = error
  })
  if (isLoading) store.commit('showLoadMask', false)
  return resData
}
/**
 * POST 方式上传文件请求
 */
export async function fileData (hasParamUrl, data, whichPost, isLoading, callback) {
  if (hasParamUrl === null) return
  if (isLoading) store.commit('showLoadMask', true)
  initAxios(whichPost, true)
  let resData
  await axios.post(hasParamUrl, data).then(function (response) {
    // 存储token到Vuex的state
    // store.commit('setTokenStr', response.data.tokenStr)
    backView(response, callback)
    resData = response.data
  }).catch(function (error) {
    console.log(error)
    resData = error
  })
  if (isLoading) store.commit('showLoadMask', false)
  return resData
}

/**
 * DELETE 方式请求
 */
export async function delData (hasParamUrl, data, whichPost, isLoading, callback) {
  if (hasParamUrl === null) return
  if (isLoading) store.commit('showLoadMask', true)
  initAxios(whichPost)
  let resData
  await axios.delete(hasParamUrl, data).then(function (response) {
    backView(response, callback)
    resData = response.data
  }).catch(function (error) {
    console.log(error)
    resData = error
  })
  if (isLoading) store.commit('showLoadMask', false)
  return resData
}

/**
 * POST 方式请求（传送到服务器的是一个json对象）
 * @param requestUrl 请求url
 * @param params  (如下的param)
 *      var param = new URLSearchParams
 *      param.append('name', 'mirzhao')
 * @param callback 回调函数
 */
export async function postStringParamData (hasParamUrl, params, callback) {
  if (hasParamUrl === null) return
  initAxios()
  await axios.post(hasParamUrl, JSON.stringify(params)).then(function (response) {
    backView(response, callback)
  }).catch(function (error) {
    console.log(error)
  })
}
/**
 * 获取到数据后——统一处理最外层对象
 * @param response
 * @param callback
 */
async function backView (response, callback) {
  // 打印返回的数据实体  reponse.data才是服务器返回的数据
  // console.log(response, callback)
  if (response != null && response.data != null && response.data.code === 200) {
    // console.log('请求成功')
    // store.commit('setTokenStr', response.data.tokenStr)
    if (callback != null) {
      await callback(response.data)
    } else {
      return response.data
    }
  } else {
    // console.log('请求失败')
    if (callback != null) {
      await callback(response.data.message)
    } else {
      return response.data
    }
  }
}
// 服务器返回的状态
// console.log(response.status)
// console.log(response.statusText)
// console.log(response.headers)
// console.log(response.config)

// export default {
//   getData,
//   postData,
//   postStringParamData
// }
